import {
  fetchOauthClients,
  requestOpenIdProviderLink,
  requestRedirectURIByProviderID,
  submitOpenIDAuthCodeByProviderID,
} from "@mne-authentication/api";
import type {
  IAuthenticationData,
  IFetchOauthClientsParams,
  IOauthClient,
  IRequestOpenIdProviderLinkCriteria,
  IRequestRedirectURIByProviderIDCriteria,
  IRequestRedirectURIByProviderIDResponse,
  ISubmitOpenIDAuthCodeByProviderIDCriteria,
} from "@mne-authentication/api";
import type { IResultstash } from "@mne-core/api";

import { ArgusUtils } from "@mnemonic/pure-utils";
import { handleResponse } from "@mnemonic/redux-utils";

import { getSessionKey } from "../utils/getSessionKey";
import type { IBaseApiParams, TMetaOpts } from "./baseApi";
import { baseApi } from "./baseApi";

const openIdProviderApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    requestOpenIdProviderLink: build.query<
      IResultstash<object>,
      { criteria: IRequestOpenIdProviderLinkCriteria; metaOpts?: TMetaOpts }
    >({
      queryFn: ({ criteria, metaOpts }) =>
        handleResponse(requestOpenIdProviderLink(criteria, { apiUrl: ArgusUtils.getApiUrl() }), metaOpts),
    }),
    requestRedirectURIByProviderID: build.query<
      IResultstash<IRequestRedirectURIByProviderIDResponse>,
      IBaseApiParams<IRequestRedirectURIByProviderIDCriteria>
    >({
      queryFn: ({ criteria, metaOpts }) =>
        handleResponse(requestRedirectURIByProviderID(criteria, { apiUrl: ArgusUtils.getApiUrl() }), metaOpts),
    }),
    fetchOauthClients: build.query<IResultstash<Array<IOauthClient>>, IBaseApiParams<IFetchOauthClientsParams>>({
      queryFn: ({ criteria, metaOpts }, api) =>
        handleResponse(
          fetchOauthClients(criteria, { apiUrl: ArgusUtils.getApiUrl(), sessionKey: getSessionKey(api) }),
          metaOpts,
        ),
    }),
    /* Mutations */
    submitOpenIDAuthCodeByProviderID: build.mutation<
      IResultstash<IAuthenticationData>,
      IBaseApiParams<ISubmitOpenIDAuthCodeByProviderIDCriteria>
    >({
      queryFn: ({ criteria, metaOpts }) =>
        handleResponse(submitOpenIDAuthCodeByProviderID(criteria, { apiUrl: ArgusUtils.getApiUrl() }), metaOpts),
    }),
  }),
});

export const {
  useRequestOpenIdProviderLinkQuery,
  useFetchOauthClientsQuery,
  useRequestRedirectURIByProviderIDQuery,
  useSubmitOpenIDAuthCodeByProviderIDMutation,
} = openIdProviderApi;

export default openIdProviderApi;
